import moment from "moment";
import { useEffect, useRef, useState } from "react";
import "react-quill/dist/quill.snow.css";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import { addlog } from "../../../utils/ApiCalls/Logs";
import {
  createShipMobilePage,
  updateShipMobilePage,
} from "../../../utils/ApiCalls/AddShipMobilePage";
import { uploadFile } from "../../../utils/ApiCalls/Document";
import { getSailingPageData } from "../../../utils/ApiCalls/SailingData";
import { getVessels } from "../../../utils/ApiCalls/SpecialPage";
import { getShorexPackages } from "../../../utils/ApiCalls/BackOffice/Shorex";
import { checkFields } from "../../../utils/Validation/checkFields";
import { MOBILE_LOG_TYPES } from "../../../constants/logging";
import DyanmicFromMobile from "../../DyanmicForm/DyanmicFromMobile";
import { fieldsName, mobile_fields } from "./MobilePageFields";
import { Button } from "@mui/material";
import { useDebounce } from "../../../hooks";

const ShipMobilePagemasterInput = ({
  pageData,
  category,
  activityCategory,
  vesselData,
  shore_page_id,
}) => {
  const [isActive, setIsActive] = useState(true);

  const [vesselOptions, setVesselOptions] = useState([]);
  const [fields, setFields] = useState([]);
  const [sailing_date, setSailingDate] = useState("");
  const parms = useParams();
  const [shoreCMS, setShoreCMS] = useState({});
  const originalShipData = useRef({});
  const [sailingId, setSailingId] = useState("");
  const [{ userDetails }, dispatch] = useDataLayerValue();
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [shorexDetails, setShorexDetails] = useState(null);
  const [shorexNotFound, setShorexNotFound] = useState(false);
  const [shorexDisabled, setShorexDisabled] = useState(false);
  const packageIdCode = shoreCMS?.fidelio_code?.package_id;
  const debouncedPackageIdCode = useDebounce(packageIdCode, 800);

  useEffect(() => {
    if (!debouncedPackageIdCode || !sailingId) {
      setShorexDetails(null);
      setShorexNotFound(false);
      setShorexDisabled(false);
      if (!debouncedPackageIdCode) {
        setShoreCMS((prev) => ({
          ...prev,
          fidelio_code: {
            ...prev.fidelio_code,
            fidelio_id: "",
            package_name: "",
          },
        }));
      }
      return;
    }
    const matchPackageId = async () => {
      const res = await getShorexPackages({
        packageId: sailingId,
        excNo: debouncedPackageIdCode,
        limit: 200,
      });
      const match = res?.error ? null : (res?.data || [])[0];

      if (match) {
        setShorexDetails(match);
        setShorexNotFound(false);
        setShorexDisabled(!match.linkEnabled);
        setShoreCMS((prev) => ({
          ...prev,
          fidelio_code: {
            ...prev.fidelio_code,
            fidelio_id: String(match.excId),
            package_name: match.name,
          },
        }));
      } else {
        setShorexDetails(null);
        setShorexNotFound(true);
        setShorexDisabled(false);
        setShoreCMS((prev) => ({
          ...prev,
          fidelio_code: {
            ...prev.fidelio_code,
            fidelio_id: "",
            package_name: "",
          },
        }));
      }
    };
    matchPackageId();
  }, [debouncedPackageIdCode, sailingId]);

  useEffect(() => {
    if (pageData) {
      setSailingDate(pageData?.sailing_date);
      setIsActive(pageData?.is_active);
      const shipData = pageData?.ship_data || {};
      setShoreCMS(shipData);
      originalShipData.current = JSON.parse(JSON.stringify(shipData));
      setSailingId(pageData?.package_id || "");
    }
  }, [pageData, vesselData]);

  useEffect(() => {
    if (category?.id && category?.ship_cms) {
      let val = Array(fieldsName.length).fill("hii");
      Object.keys(category.ship_cms).forEach((item) => {
        if (category.ship_cms[item] === true) {
          if (mobile_fields[item]) {
            let index = fieldsName.findIndex((val) => val == item);
            val[index] = mobile_fields[item];
          }
        }
      });
      console.log({ category: category?.action_type });
      if (
        category?.action_type === "purchase" ||
        category?.action_type === "reserve" ||
        category?.action_type === "link"
      ) {
        val.push(mobile_fields["cta"]);
      }
      if (category?.action_type === "link") {
        val.push(mobile_fields["cta_button_data"]);
      }
      val = val.filter((item) => item != "hii");
      setFields(val);
    }
  }, [category]);
  const handleCheckboxChange = () => {
    setIsActive(!isActive);
  };
  const fileKeys = [
    "image",
    "image1",
    "image2",
    "image3",
    "image4",
    "image5",
    "arabic_image",
    "simplified_chinese_image",
    "traditional_chinese_image",
    "popup_image",
    "simplified_chinese_popup_image",
    "traditional_chinese_popup_image",
    "english_file",
    "simplified_chinese_file",
    "traditional_chinese_file",
    "star_cruises_english_file",
    "star_cruises_simplified_chinese_file",
    "star_cruises_traditional_chinese_file",
    "arabic_file",
    "logo",
    "simplified_chinese_logo",
    "english_menu",
    "simplified_chinese_menu",
    "traditional_chinese_menu",
    "traditional_chinese_logo",
    "arabic_logo",
    "english_file_1",
    "simplified_chinese_file_1",
    "traditional_chinese_file_1",
    "arabic_file_1",
    "english_file_2",
    "simplified_chinese_file_2",
    "traditional_chinese_file_2",
    "arabic_file_2",
  ];
  const uploadImagesRecursively = async (data, originalData = {}) => {
    try {
      for (const key in data) {
        if (data[key] && typeof data[key] === "object") {
          for (const fileKey of fileKeys) {
            if (data[key].hasOwnProperty(fileKey)) {
              const fileValue = data[key][fileKey];
              const oldValue = typeof originalData[key]?.[fileKey] === "string" ? originalData[key][fileKey] : null;
              if (fileValue instanceof File) {
                data[key][fileKey] = await handleFileUpload(fileValue, fileKey, oldValue);
              } else if (typeof fileValue === "string" && fileValue.trim() !== "") {
                data[key][fileKey] = fileValue;
              } else {
                data[key][fileKey] = "";
              }
            }
          }

          await uploadImagesRecursively(data[key], originalData[key] || {});
        }
      }
    } catch (e) {
      console.log(e);
      Swal.fire(e.message);
    }
  };
  async function handleFileUpload(selectedFile, fileKey, oldFileName = null) {
    if (typeof selectedFile === "string") {
      return selectedFile;
    } else {
      let real;
      if (fileKey?.toString()?.includes("file")) {
        real = "yes";
      }
      try {
        const uploadedFile = await uploadFile(selectedFile, {}, real, oldFileName);
        if (uploadedFile?.error) throw new Error(uploadedFile.error);
        return uploadedFile.url;
      } catch (error) {
        console.error(`Upload error for ${fileKey}:`, error);
        return "";
      }
    }
  }

  useEffect(() => {
    if (sailing_date) {
      console.log({ sailing_date });
      getSailingPageDate();
    }
  }, [sailing_date]);
  const getSailingPageDate = async () => {
    let res = await getSailingPageData({ sailing_date });
    if (res?.error) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: res.error, type: "error" },
      });
    }
    console.log({ res: res.data });
  };

  const cleanShipData = (obj) => {
    if (Array.isArray(obj)) return obj.map(cleanShipData);
    
    if (obj instanceof File) return obj;
    
    if (obj && typeof obj === "object") {
      const cleaned = {};
      Object.keys(obj).forEach((key) => {
        if (!/^\d+$/.test(key)) {
          cleaned[key] = cleanShipData(obj[key]);
        }
      });
      return cleaned;
    }
    return obj;
  };

  const addcrisisData = async (e) => {
    e.preventDefault();

    if (shorexDisabled) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: {
          message: "This shore excursion code is not enabled and cannot be used",
          type: "error",
        },
      });
      return;
    }

    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    const cleanedShoreCMS = cleanShipData(shoreCMS);
    // maximum_count comes off a type="number" input as a numeric string -
    // coerce to a real number only when something was actually entered;
    // left empty, it stays empty (no 0 default - that would misleadingly
    // read as "maximum 0 participants")
    if (cleanedShoreCMS?.no_of_pat) {
      const { maximum_count } = cleanedShoreCMS.no_of_pat;
      if (maximum_count !== "" && maximum_count !== undefined && maximum_count !== null) {
        cleanedShoreCMS.no_of_pat.maximum_count = Number(maximum_count);
      }
    }

    let dataValues = {
      sailing_date: sailing_date,
      catergory_id: category?.id,
      shore_page_id: shore_page_id,
      ship_data: cleanedShoreCMS,
      is_active: isActive ? 1 : 0,
    };

    let newValues = [dataValues];
    await uploadImagesRecursively(newValues, [{ ship_data: originalShipData.current }]);
    dataValues = newValues[0];

    let valid = checkFields(dataValues);

    if (valid) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: valid, type: "error" },
      });
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
      setError(valid);
    } else {
      setError();

      const values = {
        ...dataValues,
      };

      let data;
      if (pageData?.id) {
        data = await updateShipMobilePage(pageData?.id, {
          ...values,
          vesselData,
        });
      } else {
        data = await createShipMobilePage(values);
      }

      if (data?.error) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: data.error, type: "error" },
        });
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
        return;
      }

      await addlog(
        pageData?.id ? MOBILE_LOG_TYPES.ACTIONS.PAGE_CONTENT_UPDATED : MOBILE_LOG_TYPES.ACTIONS.PAGE_CONTENT_CREATED,
        MOBILE_LOG_TYPES.MODULE,
        {
          title: `${pageData?.shorePage?.title || pageData?.shorePage?.venue?.name || "Unknown Page"} content ${pageData?.id ? "updated" : "created"} for ${vesselOptions.find(v => v.id === category?.vessel_id)?.name || "Unknown Vessel"} - ${moment(localStorage.getItem("sailing-date") || sailing_date).format("DD MMM YYYY")}`,
          page_name: pageData?.shorePage?.title || pageData?.shorePage?.venue?.name || "Unknown Page",
          vessel_name: vesselOptions.find(v => v.id === category?.vessel_id)?.name || "Unknown Vessel",
          sailing_date: moment(localStorage.getItem("sailing-date") || sailing_date).format("YYYY-MM-DD"),
          category_id: category?.id,
          category_name: category?.name,
          is_active: isActive,
          page_id: pageData?.id || data?.id
        },
        userDetails.id
      );

      dispatch({
        type: "SET_LOADING",
        loading: false,
      });

      let slug =
        localStorage.getItem("old-url") ||
        "/ship/all-pages/" +
        vesselOptions
          .find((item) => item.id === category?.vessel_id)
          ?.name?.replaceAll(" ", "-")
          ?.toLowerCase() +
        "/" +
        category.id;

      if (!pageData?.id) {
        navigate(slug);
      } else {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { 
            message: pageData?.id ? "Page content updated successfully" : "Page content created successfully", 
            type: "success" 
          },
        });
        navigate(slug);
      }
    }
  };


  useEffect(() => {
    if (category?.id) getOptionLocation();
  }, [category]);

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();

    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      setVesselOptions(vessels);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  useEffect(() => {
    console.log({ vesselData });
  }, [vesselData]);
  return (
    <div>
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addcrisisData}>
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                    <h4 style={{ fontWeight: "bold" }}>Edit Page Content</h4>
                    <p>
                      {
                        vesselOptions.find(
                          (item) => item.id === category?.vessel_id
                        )?.name
                      }{" "}
                      -{" "}
                      {moment(
                        localStorage.getItem("sailing-date") || new Date()
                      ).format("DD-MMM-YYYY")}
                    </p>
                  </div>
                  <div
                    style={{
                      background: "lightgray",
                      height: "30px",
                      display: "flex",
                      border: "1px solid black",
                      alignItems: "center",
                      padding: "10px",
                      paddingBottom: "20px",
                      paddingTop: "20px",
                      marginBottom: "10px",
                      marginTop: "10px",
                      fontWeight: "400",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    className="col-lg-12"
                  >
                    <p style={{ fontSize: "20px", fontWeight: "bold" }}>
                      {pageData?.shorePage?.title ||
                        pageData?.shorePage?.venue?.name}
                    </p>
                    <Button
                      onClick={() => {
                        navigate(
                          `/shore/all-pages/${parms.vessel}/${parms.cat}/edit/${pageData?.shorePage?.id}`
                        );
                      }}
                      style={{ background: "black", color: "white" }}
                      variant="outlined"
                    >
                      Visit Page
                    </Button>
                  </div>
                  <div
                    style={{
                      height: "30px",
                      display: "flex",
                      border: "1px solid black",
                      alignItems: "center",
                      padding: "10px",
                      marginBottom: "10px",
                      marginTop: "10px",
                      fontWeight: "400",
                    }}
                    className="col-lg-12"
                  >
                    <p style={{ fontWeight: "bolder" }}>Dynamic Input Fields</p>
                  </div>
                  <DyanmicFromMobile
                    error={error}
                    rootData={shoreCMS}
                    queryData={{ vessel_id: category?.vessel_id }}
                    level={1}
                    attributes={fields || []}
                    data={shoreCMS}
                    sailingId={sailingId}
                    shorexNotFound={shorexNotFound}
                    shorexDisabled={shorexDisabled}
                    setData={(e) => {
                      setShoreCMS(e);
                    }}
                  />
                </div>
                <div className="col-12">
                  <div className="iti_inner">
                    <div className="icheck-primary d-inline">
                      <input
                        type="checkbox"
                        id="customCheckbox4"
                        name="r10"
                        checked={isActive}
                        onChange={handleCheckboxChange}
                      />
                      <label htmlFor="customCheckbox4">
                        {isActive ? (
                          <p>
                            <span style={{ fontWeight: 600 }}>Active</span>
                          </p>
                        ) : (
                          <p>
                            <span style={{ fontWeight: 200 }}>Active</span>
                          </p>
                        )}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer text-right">
                <button className="btn main_submit">
                  {pageData?.id ? "Update" : "Add"} Page
                </button>
              </div>
            </form>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};

export default ShipMobilePagemasterInput;
